<script lang="ts" setup>
import { onMounted } from 'vue'

import { useSessionStore } from '../stores/session'
import { useConfigStore } from '../stores/config'

const cpBaseUrl = useConfigStore().rsConfig.contentPass.cpBaseUrl as string
const cpPropertyId = useConfigStore().rsConfig.contentPass.cpPropertyId as string
const cpController = `${cpBaseUrl}/now.js` as string
const sessionStore = useSessionStore()

// You can find a sample integration for this on
// https://docs.contentpass.net/docs/3rdparty

const injectContentPassIntegration = () => {
  const script = document.createElement('script')
  script.innerHTML = `(function() {
    !function(C,o,n,t,P,a,s){C.CPObject=n,C[n]||(C[n]=function(m,x){
    C[n].q||(C[n].q=[]),
    C[n].q.push(arguments),C[n].patched||("fatal"===m&&x&&(C[n].le=x,
    Array.prototype.forEach.call(C[n].q,(function(e){
    'error'===e[0]&&'function'==typeof e[1]&&e[1](x)
    }))),C[n].le&&'error'===m&&'function'==typeof x&&x(C[n].le))}),C[n].l=+new Date,
    C[n].sv=4,(a=o.createElement(t)).onerror=function(e){C[n]('fatal',e)
    },a.src=P,(s=o.getElementsByTagName(t)[0]).parentNode.insertBefore(a,s)
    }(window,document,'cp','script','${cpController}');

    !function(C,o,n,t,P,a,s){C[n]&&!C[n].patched&&(C[n]("extension","authenticate"),
      P=C[n].q.push,C[n].q.push=function(e){if("authenticate"===e[0]){try{
      t=-1===(o.cookie||'').indexOf('_cpauthhint=')&&!(C.localStorage||{})._cpuser&&
      -1===C.location.href.toLowerCase().indexOf('cpauthenticated')}catch(e){t=!1}if(t)
      return a={isLoggedIn:function(){return!1},hasValidSubscription:function(){return!1}},
      'function'==typeof e[1]&&e[1](null,a),C[n].afp=!0,P.apply(C[n].q,[['authenticate',null]]),a}
      return P.apply(C[n].q,[e])})
    }(window,document,'cp');

    cp('create', '${cpPropertyId}', {
      baseUrl: '${cpBaseUrl}'
    });
  })();`
  document.head.appendChild(script)
}

const injectContentPassSourcepointFastPath = () => {
  const script = document.createElement('script')
  script.innerHTML = `(function () {
    cp('authenticate', function(err, user) {
      if (err || (!user.isLoggedIn() && !user.hasValidSubscription())) {
        (function spExecMsg() {
          if (window._sp_ && window._sp_.executeMessaging) {
            if (!window._sp_.config.isSPA) {
              console.warn('[SPCP] Sourcepoint not in SPA mode!');
            } else {
              // Starting Sourcepoint
              window._sp_.executeMessaging();
            }
          } else {
            // Sourcepoint not loaded yet. Retrying.
            setTimeout(spExecMsg, 10);
          }
        })();
      }
    });
  })();`
  document.head.appendChild(script)
}

onMounted(() => {
  injectContentPassIntegration()
  injectContentPassSourcepointFastPath()
  sessionStore.updateContentPassStatus()
  sessionStore.initContentPassStatus()
})
</script>

<template>
  <div id="cp-container"
       class="hidden h-0 w-0" />
</template>
